module.exports = __webpack_public_path__ + "static/media/10.27fda39c.mp3";